import {CircleF, OverlayView, OverlayViewF} from '@react-google-maps/api'
import {mapStore} from '../../../../../../store/mapStore'
import {BiTrash} from 'react-icons/bi'

const ComerciosMarker = () => {
  // const onClick = useCallback(() => {
  //   console.info('I have been clicked!')
  // }, [])
  const {comercios, removeComercio} = mapStore()

  if (!comercios) {
    return <></>
  }

  const circleOptions: google.maps.CircleOptions = {
    strokeColor: '#098100',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#d1d1d1',
    fillOpacity: 0.35,
    center: comercios.center,
    radius: comercios.raio,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    zIndex: 1,
  }

  const infoWindowStyle = {
    // background: `white`,
    // border: `1px solid ##CCC`,
    // padding: 15,
  }
  function removeItem(item) {
    removeComercio(item)
  }
  return (
    <>
      <CircleF options={circleOptions} />

      {comercios.list.map((item) => {
        if (item.active) {
          return (
            <OverlayViewF
              position={{lat: item.location.latitude, lng: item.location.longitude}}
              // mapPaneName={OVERLAY_MOUSE_TARGET}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
              getPixelPositionOffset={(width, height) => ({
                x: -(width / 2),
                y: -height / 2,
              })}
            >
              <div style={infoWindowStyle}>
                <div className='d-flexx label-content'>
                  <div className='label-marker d-flex justify-content-center align-items-center'>
                    {item.displayName.text || '-'}
                    <img
                      src={item.iconMaskBaseUri + '.svg'}
                      style={{backgroundColor: item.iconBackgroundColor}}
                      className='icons'
                      alt='as'
                      // width={5}
                    />
                    <div className='actions position-absolute ' style={{right: 0}}>
                      <button
                        className='btn p-0 px-2 py-1 rounded-circle'
                        style={{backgroundColor: '#fff'}}
                        onClick={() => removeItem(item.id)}
                      >
                        <BiTrash className='text-danger fs-2'></BiTrash>
                      </button>
                    </div>
                  </div>

                  <div
                    className='label-dot'
                    style={{display: 'block !important', backgroundColor: item.iconBackgroundColor}}
                  ></div>
                </div>
              </div>
            </OverlayViewF>
          )
        }
        return <></>
      })}
    </>
  )
}
export default ComerciosMarker
